import { z } from 'zod';

import { useSearchParams as useBaseSearchParams } from '@/common/composables/router';
import { COUNTRIES, marketplaces } from '@/common/constants';
import { buildSearchParamsSortScheme, searchParamsQueryScheme } from '@/helpers/zod';
import type { CountryCode } from '@/types/country';

const searchParamsScheme = z.object({
  country: z.custom<CountryCode>(value => COUNTRIES.some(country => country === value)).catch('USA'),
  keyword: z.string()
    .transform((value) => value
      .replace(/<[^>]*>/g, '')
      .replace(/["\\$@!?%^&*()\-+=:;<>']/g, '')
      .replace(/\s+/g, ' ')
      .trim())
    .catch(null),
  marketplaces: searchParamsQueryScheme
    .merge(buildSearchParamsSortScheme([
      'avg_clicks.order_value',
      'ctr.order_value',
      'avg_searches.order_value',
      'marketplace',
      'search_trend',
    ]))
    .optional(),
  source: z.custom<string>(value => marketplaces.some(marketplace => marketplace.code === value)).catch('etsy'),
});

export type SearchParamsSchemeType = z.infer<typeof searchParamsScheme>;

export function useSearchParams() {
  return useBaseSearchParams(searchParamsScheme);
}
